import { getOrElseW, mapLeft } from 'fp-ts/Either'
import { flow } from 'fp-ts/function'
import { literal, strict, string, union } from 'io-ts'
import { formatValidationErrors } from 'io-ts-reporters'

const throwHumanReadableErrors = (errors: Array<string>): never => {
  const error = new Error(`\n${errors.map(error => '❗ ' + error).join('\n')}`)
  error.name = 'EnvironmentVariablesDecodeError'
  throw error
}

const getEnvVariables = flow(
  strict,
  Codec => Codec.decode(process.env),
  mapLeft(formatValidationErrors),
  getOrElseW(throwHumanReadableErrors),
)

export const env = getEnvVariables({
  REACT_APP_CLIENT_ID: string,
  REACT_APP_STRIPE_PRIVATE_KEY: string,
  REACT_APP_SIGN_UP_AVAILABLE: union([literal('true'), literal('false')]),
  REACT_APP_LIBRARIA_GITHUB_REPO: string,
  REACT_APP_LIBRARIA_FIGMA_APP: string,
})
